var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, Watch } from "vue-facing-decorator";
import { CompaniesClient, IssuesClient, SettingsClient, ReportScheduleModel, GetIssueSiteSummaryQuery } from "@/app/api/battery-portal-api";
import { Notifier } from "@//common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { DownloadUtil } from "@/app/utils/download-util";
import moment from "moment";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const companyClient = new CompaniesClient(window.apiUrl);
const issuesClient = new IssuesClient(window.apiUrl);
const settingsClient = new SettingsClient(window.apiUrl);
let SiteIssueSummaryReportFilterVue = class SiteIssueSummaryReportFilterVue extends Vue {
    constructor() {
        super(...arguments);
        this.working = false;
        this.displayAdvancedFilter = false;
        this.companies = [];
        this.query = new GetIssueSiteSummaryQuery();
    }
    created() {
        this.getLookups();
    }
    ;
    mounted() {
        this.loadReportScheduleQuery();
    }
    ;
    getLookups() {
        this.working = true;
        let promises = [
            companyClient
                .getListGET()
                .then(response => {
                let companies = (response || []).map((item) => {
                    return {
                        value: item.companyId,
                        text: item.companyName || ""
                    };
                });
                this.companies = companies;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
            })
        ];
        Promise.all(promises).then(() => {
            this.working = false;
        });
    }
    ;
    getQuery() {
        if (!this.validateParameters())
            return null;
        this.query.timezoneOffset = moment().utcOffset();
        return this.query;
    }
    ;
    validateParameters() {
        try {
            if (!this.query.companyId) {
                Notifier.onWarning("Select a Company!");
                return false;
            }
            if (Number(this.query.rangeColumn1) < 1 || Number(this.query.rangeColumn1) > 100) {
                Notifier.onWarning("Lower Range must be between 1 and 100");
                return false;
            }
            if (Number(this.query.rangeColumn2) < 1 || Number(this.query.rangeColumn2) > 100) {
                Notifier.onWarning("Middle Range must be between 1 and 100");
                return false;
            }
            if (Number(this.query.rangeColumn3) < 1 || Number(this.query.rangeColumn3) > 100) {
                Notifier.onWarning("Upper Range must be between 1 and 100");
                return false;
            }
            if (Number(this.query.rangeColumn1) >= Number(this.query.rangeColumn2)) {
                Notifier.onWarning("range Lower Range cannot be greater than or equal to Middle Range");
                return false;
            }
            if (Number(this.query.rangeColumn2) >= Number(this.query.rangeColumn3)) {
                Notifier.onWarning("Calendar range Middle Range cannot be greater than or equal to Upper Range");
                return false;
            }
            return true;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    exportToPdf() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            issuesClient.downloadIssueSiteSummaryAsPdf(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                let blob = new Blob([response.data], { type: 'application/pdf;base64' });
                let url = URL.createObjectURL(blob);
                var popUp = window.open(url, '_blank');
                if (popUp == null || typeof (popUp) == 'undefined') {
                    alert('Please disable your pop-up blocker and try again.');
                }
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
        handleSubmitAction();
    }
    ;
    exportToCsv() {
        if (this.working)
            return;
        var query = this.getQuery();
        if (query == null)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            issuesClient.downloadIssueSiteSummaryAsCsv(query)
                .then(response => {
                if (!response) {
                    Notifier.onWarning("Could not download report data.");
                    return;
                }
                DownloadUtil.handleFileDownload(response);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
        handleSubmitAction();
    }
    ;
    getScheduleButtonLabel() {
        return this.reportScheduledModel ? "Update schedule" : "Schedule";
    }
    ;
    onReportScheduledModelChanged() {
        this.loadReportScheduleQuery(false);
    }
    ;
    onCompanyIdChanged() {
        if (this.working)
            return;
        this.loadSavedSettingsForCompany();
    }
    setValidationFields() {
        this.setFieldValue("rangeColumn1", this.query.rangeColumn1);
        this.setFieldValue("rangeColumn2", this.query.rangeColumn2);
        this.setFieldValue("rangeColumn3", this.query.rangeColumn3);
    }
    loadSavedSettingsForCompany() {
        settingsClient
            .getIssueSiteSummaryReportSettingsForCompany(this.query.companyId)
            .then((response) => {
            if (!response)
                return;
            this.query.rangeColumn1 = response.rangeColumn1;
            this.query.rangeColumn2 = response.rangeColumn2;
            this.query.rangeColumn3 = response.rangeColumn3;
            this.setValidationFields();
        });
    }
    ;
    schedule() {
        var reportQuery = this.getQuery();
        if (reportQuery == null)
            return;
        var queryString = JSON.stringify(reportQuery);
        this.$emit(this.reportScheduledModel ? "updateSchedule" : "schedule", queryString);
    }
    ;
    loadReportScheduleQuery() {
        var _a, _b;
        if (!this.reportScheduledModel)
            return;
        this.working = true;
        var queryString = (_b = (_a = this.reportScheduledModel) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : "";
        try {
            var query = JSON.parse(queryString);
            this.query.companyId = query.companyId;
            this.query.rangeColumn1 = query.rangeColumn1;
            this.query.rangeColumn2 = query.rangeColumn2;
            this.query.rangeColumn3 = query.rangeColumn3;
            this.setValidationFields();
        }
        catch (ex) {
            console.error(ex);
        }
        finally {
            this.$nextTick(() => {
                this.working = false;
            });
        }
    }
    ;
    get selectedCompanyId() {
        return this.companies.filter(item => {
            return item.value == this.query.companyId;
        })[0] || null;
    }
    ;
    set selectedCompanyId(item) {
        if (!item)
            return;
        this.query.companyId = item.value;
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof ReportScheduleModel !== "undefined" && ReportScheduleModel) === "function" ? _a : Object)
], SiteIssueSummaryReportFilterVue.prototype, "reportScheduledModel", void 0);
__decorate([
    Watch("reportScheduledModel"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SiteIssueSummaryReportFilterVue.prototype, "onReportScheduledModelChanged", null);
__decorate([
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], SiteIssueSummaryReportFilterVue.prototype, "onCompanyIdChanged", null);
SiteIssueSummaryReportFilterVue = __decorate([
    Component({
        name: "SiteIssueSummaryReportFilterVue",
        emits: ["schedule", "updateSchedule"],
        setup() {
            const { errors, handleSubmit, defineInputBinds, setFieldValue } = useForm({
                validationSchema: yup.object({
                    rangeColumn1: yup.number().integer().min(1).max(100),
                    rangeColumn2: yup.number().integer().min(1).max(100),
                    rangeColumn3: yup.number().integer().min(1).max(100),
                })
            });
            const rangeColumn1Val = defineInputBinds('rangeColumn1');
            const rangeColumn2Val = defineInputBinds('rangeColumn2');
            const rangeColumn3Val = defineInputBinds('rangeColumn3');
            return {
                errors,
                handleSubmit,
                setFieldValue,
                rangeColumn1Val,
                rangeColumn2Val,
                rangeColumn3Val,
            };
        }
    })
], SiteIssueSummaryReportFilterVue);
export default SiteIssueSummaryReportFilterVue;
